// extracted by mini-css-extract-plugin
export default {"confirmationModal":"NewVersionPopup_confirmationModal__HWlpA","confirmationModalActions":"NewVersionPopup_confirmationModalActions__XKoPi"};